import scrollStyles from './media/shared/scroll-progress.module.css'

type CustomElement = new (...args: any[]) => HTMLElement

/*
 * Mixin for animating scroll progress..
 * Currently used for video.
 *
 * TODO: Replace with css scroll-driven animations once major browsers support lands
 */
export function ScrollProgressMixin<TBase extends CustomElement>(Base: TBase) {
  return class extends Base {
    connectedCallback() {
      // @ts-ignore
      super.connectedCallback?.()

      // Set up animation per placeholder card
      for (const placeholderCard of this.placeholderCards) {
        /* Timeline starts when placeholder card enters the screen from below,
        and ends when placeholder card exits at the top of the screen */
        // @ts-ignore
        const timeline = new ViewTimeline({
          subject: placeholderCard,
          axis: 'block',
        })

        const backgroundID = placeholderCard?.getAttribute('data-show-background')
        const backgroundElement = placeholderCard?.parentElement?.querySelector(
          `[data-background-id="${backgroundID}"]`,
        )
        const target = backgroundElement?.querySelector(`.${scrollStyles.scrollProgress}`)
        if (!target) {
          continue
        }

        // eslint-disable-next-line compat/compat
        const effect = new KeyframeEffect(
          target,
          { '--dhhs-progress': [0, 0.5, 1] },
          { fill: 'both' },
        )

        // eslint-disable-next-line compat/compat
        const animation = new Animation(effect, timeline)
        animation.play()
      }
    }

    disconnectedCallback() {
      // @ts-ignore
      super.disconnectedCallback?.()
    }

    get placeholderCards() {
      return Array.from(this.querySelectorAll('[data-scroll-progress]')) as HTMLElement[]
    }
  }
}
